import BaseStore from './BaseStore'

export class NoticeStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'notices'
  }
}

export default new NoticeStore()


// WEBPACK FOOTER //
// ./src/stores/NoticeStore.js